<ng-container *transloco="let t" class="container">
    <div class="p-3">
        <div class="modal-header">
            @if (componentState !== ImportCompetitorsModalState.SUCCESS) {
            <h5 class="modal-title">
            {{ t("race.management.competitors.import.panel.title") }}
            </h5>
            }
            <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
            </button>
        </div>
        <div class="modal-body">
            @switch (componentState) {
                @case (ImportCompetitorsModalState.IMPORT) {
                    <ng-template [ngTemplateOutlet]="import"></ng-template>
                }
                @case (ImportCompetitorsModalState.ERROR) {
                    <ng-template [ngTemplateOutlet]="error"></ng-template>
                }
            }
        </div>
        <div class="modal-footer">
            <div class="d-flex justify-content-end">
                @if (componentState === ImportCompetitorsModalState.IMPORT || componentState === ImportCompetitorsModalState.ERROR) {
                        <app-button (onClick)="onDismissClick()" [label]="t('app.common.cancel')"
                            [btnClass]="'btn-grey text-uppercase'"></app-button>
                 }
                @if (componentState === ImportCompetitorsModalState.IMPORT) {
                <div class="ms-3">
                    <app-button (onClick)="onSave()" [label]="t('app.common.confirm')"
                                [btnClass]="'btn-primary-red text-uppercase'"
                                [isDisabled]="!selectedFile"></app-button>
                </div>
                }
            </div>
        </div>
    </div>

<!--    IMPORT FORM-->
    <ng-template #import>
        <div>
                        <span>
                          <span class="fw-bold">{{ t("race.management.competitors.import.step.1") }}:</span>
                            {{ t("race.management.competitors.import.step.descrtiption.1") }}
                        </span>
        </div>
        <div class="d-flex justify-content-center align-items-center pt-3">
            <app-rounded-button [label]="t('race.management.competitors.import.download.template')"
                                [btnClass]="'rounded-button--button-black-solid'"
                                (onClick)="downloadTemplate()">
                <i class="bi bi-file-earmark-arrow-down pe-2"></i>
            </app-rounded-button>
        </div>
        <div class="pt-4 pb-3">
                <span>
                  <span class="fw-bold">{{ t("race.management.competitors.import.step.1") }}: </span>
                </span>
            <span>
                  {{ t("race.management.competitors.import.step.descrtiption.2") }}
                </span>
        </div>
        <div class="pb-3">
            <app-drag-and-drop [fileType]="FileType.XLS" (fileChange)="competitorFileAdded($event)"
                               [selectedFile]="selectedFile"/>
        </div>
        <div class="form-floating mb-3 pb-3">
            <app-select [hasDefault]="false" [items]="importTypes"
                        labelKeyPrefix="race.management.competitors.import.type."
                        label="race.management.competitors.import.type"
                        (ngModelChange)="onImportTypeChange($event)" [ngModel]="importType"/>
        </div>
    </ng-template>

    <!--    ERROR STATE-->
    <ng-template #error>
           <span>
                {{t("race.management.competitors.import.xls.error")}}
            </span>
        <div class="pt-2">
            @for(key of rowErrorKeys; track key){
            <div>
               <div class="fst-italic">
                     <span >{{t("race.management.competitors.import.xls.error.row")}} {{ key }}:</span>
                </div>

                <div *ngFor="let err of rowErrors.get(key)" class="ps-3">
                      <span class="fw-bold">{{ err[0] }}</span> - <span>{{err[1]}}</span>
                </div>
            </div>
            }

        </div>
    </ng-template>



</ng-container>
